import React from "react";
import { Images } from "../../../Assets/0a-exporter";

export default function ApplyJobSuccess({closeIt}) {
  return (
    <div className="apply-job-success-wrapper">
      <h4>Applied Successfully</h4>
      <img src={Images.ladyWalking} />
      <p>
        Congratulations!
        <br />
        You have successfully applied for job
      </p>
      <button onClick={()=>closeIt()}>Continue</button>
    </div>
  );
}
